
    var riot = require('riot')
    
import _ from 'lodash'
import moment from 'moment'
riot.tag2('saijiki-calendar', '<div class="c-saijiki-calendar"> <div class="c-saijiki-calendar__img" riot-style="{setMainImage()};"><span if="{opts.kind == \'sakura\'}">桜カレンダー</span><span if="{opts.kind == \'momiji\'}">紅葉カレンダー</span></div> <div class="c-saijiki-calendar__wrap"> <saijiki-calendar-header state="{state}"></saijiki-calendar-header> <saijiki-calendar-menus state="{state}"></saijiki-calendar-menus> <div class="c-saijiki-calendar__body"> <saijiki-calendar-table state="{state}"></saijiki-calendar-table> </div> <div class="c-saijiki-calendar__flex"> <saijiki-calendar-menus state="{state}"></saijiki-calendar-menus> <div class="c-saijiki-calendar__btn"><a href="{yearLink()}"><i class="ion-android-arrow-dropright-circle"></i><span if="{isThisYear()}">去年の情報</span><span if="{!isThisYear()}">今年の情報</span></a></div> </div> </div> </div>', '', '', function(opts) {
    const self = this

    self.state = {}
    self.state.kind = self.opts.kind
    self.state.treeStates = {}

    if ( self.state.kind == 'momiji' ) {

      self.state.treeStates = {
        1: {id: 1, name: '青し'},
        2: {id: 2, name: 'やや色づく'},
        3: {id: 3, name: '色づく'},
        4: {id: 4, name: '見頃間近'},
        5: {id: 5, name: '見頃'},
        6: {id: 6, name: '色あせ'},
        7: {id: 7, name: '落下'},
        8: {id: 8, name: '終了'},
      }
    } else {

      self.state.treeStates = {
        1: {id: 1, name: 'つぼみ'},
        2: {id: 2, name: 'ちらほら'},
        3: {id: 3, name: '三分咲き'},
        4: {id: 4, name: '五分咲き'},
        5: {id: 5, name: '八分咲き'},
        6: {id: 6, name: '満開'},
        7: {id: 7, name: '散り始め'},
        8: {id: 8, name: '葉桜'},
      }
    }

    self.state.areas   = null
    self.state.cities  = null
    self.state.sakuras = null

    self.on('mount', () => {
      self.getCalendar()
    })

    self.isThisYear = () => {
      let query = $.url().param()
      let year  = moment().format('YYYY')
      switch (true) {
        case _.isUndefined(query.year):
        case query.year == year:
          return true
        default:
          return false
      }
    }

    self.setMainImage = () => {
      return `background-image: url('/design/img/main-img/${self.opts.kind}.png')`
    }

    self.isLocal = () => {
      switch (true) {
        case _.includes(location.host, '192.168'):
        case _.includes(location.host, 'localhost'):
          return true
        default:
          return false
      }
    }

    self.yearLink = (year) => {
      let query = $.url().param()
      query.year = moment().add(-1, 'year').format('YYYY')
      if (! this.isThisYear() ) {
        query.year = moment().format('YYYY')
      }
      let qs = _.map(query, (val, key) => {
        return `${key}=${val}`
      })
      let endpoint =  `${location.pathname}?${qs.join('&')}`
      return endpoint
    }

    self.getCalendar = () => {
      try {
        let query = $.url().param()
        let endpoint = `/api/hanasaijiki/calendar/${self.state.kind}`
        if ( _.map(query).length > 0 ) {
          let newObj = _.map(query, (val, key) => {
            return `${key}=${val}`
          })
          endpoint = endpoint + `?${newObj.join('&')}`
        }

        if ( self.isLocal() ) {
          endpoint = 'http://localhost:5000/api/hanasaijiki'
        }
        $.ajax({
          url: endpoint
        })
        .done( res => {
          self.setCalendar(res)
        })
      } catch (err) {
        return null
      }
    }
    self.setCalendar = (res) => {
      self.state.areas   = res.areas
      self.state.cities  = res.cities
      self.state.sakuras = res.sakuras
      self.update()
    }

});
    
  


// WEBPACK FOOTER //
// ./_src/js/riot/saijiki-calendar/saijiki-calendar.tag